import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecd99f16"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width"]
const _hoisted_2 = ["width"]
const _hoisted_3 = ["width"]
const _hoisted_4 = ["width"]
const _hoisted_5 = ["width"]
const _hoisted_6 = ["width"]
const _hoisted_7 = ["width"]
const _hoisted_8 = ["width"]
const _hoisted_9 = ["width"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2")
], -1))
const _hoisted_11 = { class: "text-center break-word" }
const _hoisted_12 = { class: "break-word" }
const _hoisted_13 = { class: "break-word" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, null, -1))
const _hoisted_15 = { class: "break-word" }
const _hoisted_16 = { class: "text-end break-word" }
const _hoisted_17 = { class: "text-end break-word" }
const _hoisted_18 = { class: "text-end fw-bolder break-word" }
const _hoisted_19 = { class: "bao-cao-table-total-row" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "5"
}, "Cộng", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "-", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "-", -1))
const _hoisted_23 = { class: "text-end fw-bolder" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "8",
  class: "text-center"
}, "Không có dữ liệu", -1))
const _hoisted_26 = [
  _hoisted_25
]

import { computed, PropType } from "vue";
import {
  REPORT_COLUMN_WIDTHS,
  REPORT_COLUMN_WIDTHS_GROUP,
} from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";
import { ITongHopVatTuResponseBase } from "@/core/interfaces/ApiResponses";
import {
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";


export default /*#__PURE__*/_defineComponent({
  __name: 'TongHopVatTuTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  isTongHopNhap: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<ITongHopVatTuResponseBase[]>,
    default: () => [],
  },
  stripe: {
    type: Boolean as PropType<boolean>,
    required: false,
  },
},
  setup(__props) {

const colW = {
  stt: REPORT_COLUMN_WIDTHS.stt,
  ma: REPORT_COLUMN_WIDTHS.ma,
  ten: REPORT_COLUMN_WIDTHS.ten,
  dacTinh: REPORT_COLUMN_WIDTHS.dacTinh,
  dvt: REPORT_COLUMN_WIDTHS.dvt,
  soLuong: REPORT_COLUMN_WIDTHS.soLuong,
  donGia: REPORT_COLUMN_WIDTHS.donGia,
  thanhTien: REPORT_COLUMN_WIDTHS.thanhTien,
  nhapXuatTrongKy: REPORT_COLUMN_WIDTHS_GROUP.quantityDonGiaThanhTienGroup,
};

const props = __props;

const totalThanhTien = computed(() => {
  let result = 0;

  props.items.forEach(({ thanh_tien }) => {
    result += +thanh_tien;
  });

  return formatAmount(Math.round(result));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: { width: '100%', fontSize: '0.8rem' },
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    })
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.stt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ma}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ten}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dacTinh}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dvt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soLuong}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.donGia}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.thanhTien}px` })
      }, null, 4)
    ]),
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center",
          width: colW.stt
        }, "TT", 8, _hoisted_1),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.ma
        }, "Mã VT", 8, _hoisted_2),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.ten
        }, " Tên vật tư ", 8, _hoisted_3),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.dacTinh
        }, " Đặc tính ", 8, _hoisted_4),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word",
          width: colW.dvt
        }, " Đ/vị tính ", 8, _hoisted_5),
        _createElementVNode("th", {
          colspan: "3",
          class: "text-center break-word",
          width: colW.nhapXuatTrongKy
        }, _toDisplayString(__props.isTongHopNhap ? "Nhập" : "Xuất") + " trong kỳ ", 9, _hoisted_6)
      ]),
      _createElementVNode("tr", null, [
        _createElementVNode("th", {
          class: "text-center break-word",
          width: colW.soLuong
        }, "Số lượng", 8, _hoisted_7),
        _createElementVNode("th", {
          class: "text-center break-word",
          width: colW.donGia
        }, "Đơn giá", 8, _hoisted_8),
        _createElementVNode("th", {
          class: "text-center break-word",
          width: colW.thanhTien
        }, "Thành tiền", 8, _hoisted_9)
      ]),
      _hoisted_10
    ]),
    _createElementVNode("tbody", null, [
      (__props.items.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id,
                class: _normalizeClass({
            'bao-cao-table-data-row': __props.isPrintModal,
            'bao-cao-table-data-row--last':
              __props.isPrintModal && index === __props.items.length - 1,
          })
              }, [
                _createElementVNode("td", _hoisted_11, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString(item.ma_vat_tu), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(item.ten_vat_tu), 1),
                _hoisted_14,
                _createElementVNode("td", _hoisted_15, _toDisplayString(item.don_vi_tinh), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(formatQuantity)(+item.so_luong)), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_unref(formatUnitPrice)(+item.don_gia)), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(_unref(formatAmount)(Math.round(+item.thanh_tien))), 1)
              ], 2))
            }), 128)),
            _createElementVNode("tr", _hoisted_19, [
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _createElementVNode("td", _hoisted_23, _toDisplayString(totalThanhTien.value), 1)
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("tr", _hoisted_24, _hoisted_26))
    ])
  ], 2))
}
}

})